.box {
  display: flex;
  /* No explicit flex-direction default — the browser's flex default is
   * `row`, and the .dir-row / .dir-column classes below apply when the
   * consumer passes `direction` explicitly. Omitting the default here
   * keeps the class system symmetrical and avoids the dead-CSS trap
   * where `.dir-row` re-asserts what the base already declares. */
  box-sizing: border-box;
}

.inline {
  display: inline-flex;
}

/* direction */
.dir-row { flex-direction: row; }
.dir-column { flex-direction: column; }

/* align-items */
.align-start { align-items: flex-start; }
.align-center { align-items: center; }
.align-end { align-items: flex-end; }
.align-stretch { align-items: stretch; }
.align-baseline { align-items: baseline; }

/* justify-content */
.justify-start { justify-content: flex-start; }
.justify-center { justify-content: center; }
.justify-end { justify-content: flex-end; }
.justify-between { justify-content: space-between; }

/* padding — maps xs/sm/md/lg/xl → Figma --spacing-4/8/12/16/24 */
.p-xs { padding: var(--spacing-4); }
.p-sm { padding: var(--spacing-8); }
.p-md { padding: var(--spacing-12); }
.p-lg { padding: var(--spacing-16); }
.p-xl { padding: var(--spacing-24); }

/* horizontal padding */
.px-xs { padding-inline: var(--spacing-4); }
.px-sm { padding-inline: var(--spacing-8); }
.px-md { padding-inline: var(--spacing-12); }
.px-lg { padding-inline: var(--spacing-16); }
.px-xl { padding-inline: var(--spacing-24); }

/* vertical padding */
.py-xs { padding-block: var(--spacing-4); }
.py-sm { padding-block: var(--spacing-8); }
.py-md { padding-block: var(--spacing-12); }
.py-lg { padding-block: var(--spacing-16); }
.py-xl { padding-block: var(--spacing-24); }

/* gap */
.gap-xs { gap: var(--spacing-4); }
.gap-sm { gap: var(--spacing-8); }
.gap-md { gap: var(--spacing-12); }
.gap-lg { gap: var(--spacing-16); }
.gap-xl { gap: var(--spacing-24); }
